// enum of all feature flags
const FeatureFlag = {
  SalaryGuidance: 'salary_guidance',
  CandidatePositionRecommendedApply: 'candidate_position_recommend_apply',
  CandidateProfileDownload: 'candidate_profile_download',
  CandidateWhatsappChatbot: 'candidate_whatsapp_chatbot',
}

Object.freeze(FeatureFlag)

export default FeatureFlag
